import { Component, DestroyRef, EventEmitter, inject, Output } from '@angular/core';
import { MemberAuthViewModel } from '../member-auth-view-model';
import { AssetSize } from '../../../../../../models/enum/dto/asset-size.enum';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingOptions } from '../../../../../../models/shared/loading-options';

@Component({
  selector: 'app-member-send-email-verification',
  templateUrl: './member-send-email-verification.component.html',
  styleUrls: ['./member-send-email-verification.component.scss', '../../auth.component.scss']
})
export class MemberSendEmailVerificationComponent {
  private viewModel = inject(MemberAuthViewModel);
  private destroyRef = inject(DestroyRef);

  @Output() public loadingOpts = new EventEmitter<LoadingOptions>();

  public authFlowTitle$ = this.viewModel.authFlowTitle$;
  public authFlowSubtext$ = this.viewModel.authFlowSubtext$;
  public newMemberEmail$ = this.viewModel.newMemberEmail$;

  private listenToLoadingOpts = this.viewModel.loadingOpts$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(opts => this.loadingOpts.emit(opts));

  public openContactPage(): void {
    this.viewModel.openContactPage();
  }

  public resendEmail(): void {
    this.viewModel.resendEmail();
  }

  protected readonly AssetSize = AssetSize;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
